<div class="cart-empty">
  <div class="cart-empty_title">
    <p class="body-m">
      {{ 'popin-header.last-requests' | translate }} <br />
      {{ 'popin-header.build-request' | translate }}
    </p>
  </div>
  <div class="cart-empty_buttons">
    <app-button
      *appFeatureToggling="'requests-v1'"
      class="cart-empty_button"
      type="secondary"
      size="large"
      routerLink="/protected/proposal"
      text="{{ 'popin-header.requests-list' | translate }}"></app-button>
    <app-button
      *appFeatureToggling="'requests-v2'"
      class="cart-empty_button"
      type="secondary"
      size="large"
      routerLink="/protected/proposal/requests"
      text="{{ 'popin-header.requests-list' | translate }}"></app-button>
    <app-button
      class="cart-empty_button"
      size="large"
      routerLink="/protected/capture-needs"
      text="{{ 'popin-header.new-request' | translate }}"></app-button>
  </div>
</div>
